const jaJP = {
  'modal.close': '閉じる',
  'session_expired.title': 'セッションの有効期限が切れました',
  'tokenizationForm.payment-terms.text1': '私はフライワイヤーが{{recipientName}}の代理として、私のデビット/クレジットカードの情報を保存し、自動的に課金することを許可します。私は、次の内容を読み、理解した上で同意します :',
  'tokenizationForm.general-terms.link2': 'フライワイヤー プライバシーポリシー',
  'tokenizationForm.general-terms.link-joint': ' および ',
  'tokenizationForm.general-terms.link1': 'フライワイヤーの利用規約',
  'tokenizationForm.payment-terms.link': '自動支払いに関するフライワイヤーの利用規約',
  'tokenizationForm.labels.cvvTooltip': 'カードの裏面に記載されている3桁の数字、またはカードの表面に記載されている4桁の数字',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': '有効期限日 (月月/年年)',
  'tokenizationForm.labels.cardNumber': 'カード番号',
  'tokenizationForm.labels.phone': '電話番号',
  'tokenizationForm.labels.upopPhone': 'この銀行カードに登録されている携帯電話番号を入力してください',
  'tokenizationForm.labels.zip': '郵便番号',
  'tokenizationForm.labels.address': '住所',
  'cardsForm.labels.state': '州',
  'tokenizationForm.labels.country': '国または領域',
  'tokenizationForm.labels.city': '市区町村',
  'tokenizationForm.labels.email': 'Eメール',
  'tokenizationForm.labels.lastName': '姓',
  'tokenizationForm.labels.firstName': '名',
  'cardsForm.title': 'カード名義人情報',
  'success.title': '資金はまもなく到着します',
  'success.title.info': '資金の到着まで2～3営業日かかりますので予めご了承ください。資金の振込が完了すると、Eメール通知が届きます。',
  'bankAccountForm.hints.generic': '例: {{label}}',
  'bankAccountForm.hints.account_number': '口座番号の長さは1文字から17文字とする必要があります。',
  'bankAccountForm.hints.routing_number': 'ルーティング番号の長さは9桁とする必要があります。',
  'bankAccountForm.labels.accountZipCode': '郵便番号',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'BIC コード',
  'bankAccountForm.labels.accountNumber': '口座番号',
  'bankAccountForm.labels.accountSortCode': 'ソート・コード',
  'bankAccountForm.labels.accountRoutingNumber': 'Routing番号',
  'bankAccountForm.labels.accountType': '口座の種類',
  'bankAccountForm.labels.eftProviderWidnow': 'このお支払いを完了するためにパートナーの手続きプラットフォームに移動します。お支払いが完了したら、このページに再び移動します',
  'bankAccountForm.labels.termsFlywire': '私はフライワイヤーの<a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/terms/\' target=\'_blank\' rel=\'noopener noreferrer\' data-testid=\'termsOfUseLink\'>利用規約</a>および<a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/privacy/\' target=\'_blank\' data-testid=\'privacyPolicyLink\' rel=\'noopener noreferrer\'>プライバシーポリシー</a>を読み、理解したうえで同意します',
  'bankAccountForm.labels.termsDirectDebit': '私はこの口座の所有者であること、およびこの自動引き落としの承認に必要な唯一の署名者であることを確認します',
  'bankAccountForm.labels.termsEft': '私は<a class=\'fw-underline fw-text-primary-600\' href=\'https://opu.myonplanu.com/pdf/pad-agreement.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>事前承認済み口座振替契約</a>を読み、内容を理解したうえで同意します',
  'bankAccountForm.labels.city': '市区町村',
  'bankAccountForm.labels.country': '国または領域',
  'bankAccountForm.labels.selectCountry': '国または地域を選択',
  'bankAccountForm.title': '口座名義人情報',
  'failure.tryAgain': '再試行する',
  'failure.title': '取引に失敗しました',
  'failure.connectivity.message': '操作に失敗しました。接続に問題があるようです。',
  'failure.message': '取引に失敗しました。原因として接続の問題が考えられます。もう一度お試しください。引き続き問題が発生する場合は、別の支払方法をお試しになるか、銀行にお問い合わせください',
  'sessionExpired.text': 'セッションの有効期限が切れました',
  'LoadingError.title': '問題が発生しました',
  'LoadingError.message': 'フォームの読み込み中にエラーが発生しました',
  'tokenizationForm.errors.noPaymentOptionsAvailable': '選択した国/地域では利用可能な支払方法はありません。',
  'offerError.noOptions.card': 'The selected card type is not supported. Please use a different card type.',
  'offerError.noOptions.bank': 'The selected bank account is not supported. Please use a different bank account.',
  'offerError.noOptions.other': 'The selected Payment Method is not supported. Please use a different Payment Method.',
  'bankAccountForm.labels.accountHolderType.personal': '個人アカウント',
  'bankAccountForm.labels.accountHolderType.business': '企業アカウント',
  'bankAccountForm.labels.name': '名',
  'bankAccountForm.labels.businessName': '企業名',
  'bankAccountForm.labels.surname': '姓',
  'bankAccountForm.labels.phone': '電話番号',
  'bankAccountForm.labels.email': 'Eメール',
  'bankAccountForm.labels.zip': '郵便番号',
  'bankAccountForm.labels.accountAddress': '住所',
  'bankAccountForm.labels.address': '住所',
  'bankAccountForm.errors.dynamicFields': '無効な{{field}}',
  'bankAccountForm.labels.saveButton': '保存',
  'bankAccountForm.labels.nextButton': '次へ',
  'bankAccountForm.labels.payButton': '支払う',
  'bankAccountForm.errors.cardNumber': '無効なカード番号',
  'tokenizationForm.errors.cardNumber': '無効なカード番号',
  'tokenizationForm.errors.cvv': '無効な CVV 番号',
  'bankAccountForm.errors.cvv': '無効な CVV 番号',
  'tokenizationForm.errors.unsupportedCardTypes': '{{acceptedCardsList}}のみご利用いただけます',
  'tokenizationForm.errors.unsupportedCardType': '{{acceptedCard}}のみご利用いただけます',
  'tokenizationForm.errors.cardType.and': 'および',
  'tokenizationForm.errors.name': '無効な名',
  'tokenizationForm.errors.email': '無効なメールアドレス',
  'tokenizationForm.errors.country': '無効な国または地域',
  'tokenizationForm.errors.state': '州 / 都道府県が無効です',
  'tokenizationForm.errors.city': '無効な市区町村',
  'tokenizationForm.errors.address': '住所が無効です',
  'tokenizationForm.errors.addressIsPoBox': '住所フィールドでは私書箱の使用は許可されていません。',
  'tokenizationForm.errors.onlyLetterOrNumbers': '有効な文字はA～Zおよび0～9です',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol': '使用可能な文字は、A-Z、0-9、「/」、「-」のみです',
  'tokenizationForm.errors.zip': '郵便番号が無効です',
  'tokenizationForm.errors.expiryDate': '無効な有効期限日',
  'bankAccountForm.errors.expiryDate': '無効な有効期限日',
  'tokenizationForm.errors.surname': '無効な姓',
  'tokenizationForm.errors.phone': '無効な電話番号',
  'tokenizationForm.errors.length': 'フィールドへの入力文字数が長すぎます（上限は256文字）',
  'tokenizationForm.errors.required.field': '必須項目',
  'bankAccountForm.errors.name': '無効な名',
  'bankAccountForm.errors.name.maxSizeExceeded': '名前が長すぎます（最大140文字）',
  'form.errors.name.maxSizeExceeded': '名前が長すぎます（最大{{limit}}文字）',
  'form.errors.surname.maxSizeExceeded': '名字が長すぎます（最大{{limit}}文字）',
  'form.errors.business_name.maxSizeExceeded': 'ビジネス名が長すぎます（最大{{limit}}文字）',
  'form.errors.city.maxSizeExceeded': '市町村区が長すぎます（最大{{limit}}文字）',
  'form.errors.address.maxSizeExceeded': '住所が長すぎます（最大{{limit}}文字）',
  'form.errors.date.wrongDate': '日付の入力値が無効です',
  'bankAccountForm.errors.business_name': '無効な企業名',
  'bankAccountForm.errors.business_name.maxSizeExceeded': 'ビジネス名が長すぎます（最大140文字）',
  'bankAccountForm.errors.surname': '無効な姓',
  'bankAccountForm.errors.surname.maxSizeExceeded': '名字が長すぎます（最大140文字）',
  'bankAccountForm.errors.country': '無効な国または地域',
  'bankAccountForm.errors.address': '無効な住所',
  'bankAccountForm.errors.address.maxSizeExceeded': '住所が長すぎます（最大256文字）',
  'bankAccountForm.errors.city': '無効な市区町村',
  'bankAccountForm.errors.city.maxSizeExceeded': '市町村区が長すぎます（最大256文字）',
  'bankAccountForm.errors.email': '無効なメールアドレス',
  'bankAccountForm.errors.state': '州 / 都道府県が無効です',
  'bankAccountForm.errors.iban': '無効なIBAN',
  'bankAccountForm.errors.bic': '無効なBIC コード',
  'bankAccountForm.errors.accountnumber': '無効な口座番号',
  'bankAccountForm.errors.sortcode': '無効なソートコード',
  'bankAccountForm.errors.account_type': '無効な口座種別',
  'bankAccountForm.errors.addressIsPoBox': '住所フィールドでの私書箱の使用は許可されていません。',
  'bankAccountForm.errors.onlyLetterOrNumbers': '有効な文字はA～Zおよび0～9です',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': '有効な文字は以下の通りです：A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': '無効な郵便番号',
  'bankAccountForm.errors.phone': '無効な電話番号',
  'bankAccountForm.errors.ach_account_number': '無効な口座番号',
  'bankAccountForm.errors.routing_number': '無効なRouting番号 (ルーティング番号)',
  'bankAccountForm.errors.offer': '利用可能な支払方法がありません。他の国/地域に銀行口座をお持ちの場合は、その国/地域を選択するか、別のカードを選択してもう一度お試しください。これで問題が解決しない場合は、{{recipientName}}に連絡してください。',
  'binLookUp.unableToFindCard.message': 'カードエラー。入力したカード情報を確認するか、別のカードをお試しください。',
  'binLookUp.warning.message': 'お客様のカードの認証ができません',
  'confirmationPage.labels.edit': '編集',
  'confirmationPage.labels.confirm': '確定',
  'confirmationPage.labels.title': '銀行依頼情報の確認',
  'confirmationPage.labels.typeOfPayment': '支払いの種類',
  'confirmationPage.labels.paymentRecipient': '支払いの受取人',
  'confirmationPage.labels.typeOfPayment.oneOff': '単発',
  'confirmationPage.labels.typeOfPayment.recurring': '定期的',
  'confirmationPage.labels.directDebitInformation': '口座振替情報',
  'confirmationPage.labels.directDebitInformation.title': 'ご利用銀行への指示書',
  'confirmationPage.labels.directDebitInformation.creditor': '受取人',
  'confirmationPage.labels.directDebitInformation.creditorId': '受取人ID',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': '明細書への記載氏名',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'サービスユーザーID',
  'confirmationPage.labels.directDebitInformation.address': 'フライワイヤーの住所',
  'confirmationPage.labels.directDebitInformation.originator': 'Originator',
  'confirmationPage.labels.directDebitInformation.originatorId': 'OriginatorのID',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Originatorの住所',
  'confirmationPage.labels.bankAccountInformation': '銀行口座情報',
  'confirmationPage.labels.bankAccountInformation.name': '名前',
  'confirmationPage.labels.bankAccountInformation.iban': 'IBAN 番号',
  'confirmationPage.labels.bankAccountInformation.email': 'Eメール',
  'confirmationPage.labels.bankAccountInformation.country': '国または領域',
  'confirmationPage.labels.bankAccountInformation.state': '州',
  'confirmationPage.labels.bankAccountInformation.city': '市区町村',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'BIC コード',
  'confirmationPage.labels.bankAccountInformation.accountNumber': '口座番号',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'ソート・コード',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': '口座番号',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'Routing番号',
  'confirmationPage.labels.bankAccountInformation.accountType': '口座の種類',
  'confirmationPage.labels.paymentInformation': '支払情報',
  'confirmationPage.labels.paymentInformation.amount': '金額',
  'confirmationPage.labels.changeAccountEft': '銀行口座の詳細を変更',
  'confirmationPage.labels.editPayerEft': '支払者の詳細を編集',
  'confirmationPage.labels.useAccountEft': '末尾が**** {{lastFour}}の口座を使用',
  'confirmationPage.labels.bankLinkSuccessMessage': '銀行口座が正常にリンクされました',
  'confirmationPage.labels.termsSepa': 'この銀行依頼フォームに署名することにより、(A) FLYWIRE EUROPE UAB がご利用の銀行に口座振込の指示書を送ること、および (B) ご利用の銀行が、FLYWIRE EUROPE UAB の指示書の説明に従って、あなたの口座から振込を行うことを承認することになります。ご請求の3日前までに請求に関する通知が届きます。',
  'confirmationPage.labels.termsBacs': 'Flywire Payments Limitedへの口座振替はこの支払指示書に詳述される口座から支払うよう銀行に指示してください。この口座は口座振替保証で安全が保証されています。私は、この指示書がFlywire Payments Limitedに継続的に適用される場合があること、適用される場合には、私の銀行/住宅金融組合に電子的に転送されることを理解します。',
  'confirmationPage.labels.termsAch': '\n     支払者は［確定］をクリックすることで、自身に適切な権限があること、およびその権限でフライワイヤーが特定の受領者（「受取人」）を代行して、\n支払者による受取人のサービスの利用、および／または受取人の商品の購入に起因する請求額を支払者によって提供された銀行口座から引き落とすこと、\nならびに必要な場合は、受取人の条件に従い誤った引き落としを訂正することを承認すること（ただし当該承認が取り消される前に代行する場合に限定）を\n確約したことになります。資金不足によりACH取引が拒否された場合、私はNSF手数料が請求されること、およびフライワイヤーが自己裁量でこの手数料の再処理を試みる可能性があることを理解しています。\n     ',
  'confirmationPage.labels.termsAch2': '\n     支払い者は、受取人の別の商品および／またはサービスを定期的に使用または購入する場合、受取人の規約に従い、フライワイヤーが受取人を代行して、\n支払者によって提供された銀行口座から定期的に引き落とすことを承認するものとします。前述の承認された引き落とし以外の支払いでは、\n支払者が自分の口座経由で、またはパスワード、コード、その他の署名に相当する方法で事前に承認した場合のみ、\n引き落とされます。\n     ',
  'confirmationPage.labels.termsAch3': '\n     支払者は受取人に連絡することで、いつでもこの承認を取り消すことができます。支払者による取り消しは、次回支払予定日の少なくとも [10営業日]前までに\n受理される必要があります。\n    ',
  'confirmationPage.labels.print': '契約書を印刷',
  'amountPanel.labels.amountFromLabel': 'お客様のお支払い金額:',
  'amountPanel.labels.surchargeFeeInfo': 'カード手数料が含まれています',
  'amountPanel.labels.serviceFeeInfo': 'サービス手数料込み',
  'amountPanel.labels.serviceFeePercentageInfo': 'サービス手数料：{{percentage}}（最低{{minimumFee}}）',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': 'サービス手数料：{{percentage}}',
  'amountPanel.labels.whyThisFee': '手数料がかかる理由は？',
  'amountPanel.labels.currencyChangeWarning': '通貨がカードの通貨と一致するように変更されました',
  'amountPanel.labels.amountToLabel': '{{recipientName}}の受取額:',
  'amountPanel.labels.editCurrencySelection': '通貨の選択を編集',
  'amountPanel.labels.discountApplied': '{{amount}}割引が適用されました',
  'currencyInfoBanner.labels.currencyInfo': '今後のお支払いは<b>{{code}} ( {{symbol}} )</b>で請求されます。',
  'currencyInfoBanner.error.offerNotFound': '利用可能な支払方法はありません。',
  'AX': 'オーランド諸島',
  'AD': 'アンドラ',
  'BG': 'ブルガリア',
  'AT': 'オーストリア',
  'BE': 'ベルギー',
  'HR': 'クロアチア',
  'CY': 'キプロス',
  'CZ': 'チェコ共和国',
  'DK': 'デンマーク',
  'EE': 'エストニア',
  'FI': 'フィンランド',
  'FR': 'フランス',
  'GP': 'グアドループ',
  'DE': 'ドイツ',
  'GR': 'ギリシャ',
  'HU': 'ハンガリー',
  'IS': 'アイスランド',
  'IE': 'アイルランド',
  'VA': '教皇庁（バチカン市国）',
  'IT': 'イタリア',
  'LI': 'リヒテンシュタイン',
  'LT': 'リトアニア',
  'LU': 'ルクセンブルク',
  'YT': 'マヨット',
  'MT': 'マルタ',
  'MQ': 'マルティニーク',
  'ES': 'スペイン',
  'NO': 'ノルウェー',
  'NL': 'オランダ',
  'PL': 'ポーランド',
  'PT': 'ポルトガル',
  'SE': 'スウェーデン',
  'RE': 'レユニオン',
  'RO': 'ルーマニア',
  'CH': 'スイス',
  'BL': 'サン・バルテルミー島',
  'GB': '英国',
  'MC': 'モナコ',
  'MF': 'サン・マルタン（フランス領）',
  'PM': 'サンピエール島・ミクロン島',
  'SM': 'サンマリノ',
  'SK': 'スロバキア',
  'SI': 'スロベニア',
  'GF': 'フランス領ギアナ',
  'LV': 'ラトビア',
  'CA': 'カナダ',
  'US': '米国',
  'inlineDialogConfirmation.labels.title': '要確認：キャンセル処理',
  'inlineDialogConfirmation.labels.body': 'この処理をキャンセルして本当によろしいですか？',
  'inlineDialogConfirmation.labels.closeButton': 'いいえ',
  'inlineDialogConfirmation.labels.confirmButton': 'はい',
  'priceBreakDown.price.toggle.button': '料金内訳',
  'priceBreakDown.fx.toggle.button': 'FX内訳',
  'priceBreakDown.fees': '手数料',
  'priceBreakDown.service_fees': 'サービス料',
  'priceBreakDown.card_fees': 'カード手数料',
  'priceBreakDown.exchange.rate': '為替レート',
  'priceBreakDown.markup.rate': 'ECB レートからのマークアップ',
  'priceBreakDown.discount': '割引',
  'priceBreakDown.discount.coupon': '割引（{{code}}）',
  'priceBreakDown.original_amount': '元の金額',
  'priceBreakDown.total': '合計',
  'acceptProposedOfferBanner.textInfo': 'このカードは対象外です。「承認」をタップして、サポートされている支払方法に進むか、 ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard': 'このカードはご利用いただけません。「承認」をタップして、対応している支払方法に進んでください。',
  'acceptProposedOfferBanner.link.option': 'カードを変更',
  'acceptProposedOfferBanner.labels.accept': '承認する',
  'chooseCurrencyBanner.title': '通貨を選択してください',
  'chooseCurrencyBanner.message': 'カードの通貨とご請求先の国の通貨が異なります。この取引でご利用になる通貨を選択してください：',
  'banner.offer.validation.message': '続行するには、アクションを選択する必要があります。',
  'instructions.offline.amount.label': '支払額',
  'instructions.offline.reference.label': '支払い ID (Payment ID)',
  'instructions.offline.paymentId.label': '支払い ID',
  'instructions.offline.paymentReferenceMissing': '支払い IDが存在しません',
  'instructions.offline.missing.title': '支払手順の説明を生成できませんでした',
  'instructions.offline.missing.message': 'もう一度お試しください。引き続き問題が発生する場合は、別の支払方法をお試しになるか、銀行にお問い合わせください。',
  'instructions.offline.title': '支払い手順',
  'instructions.offline.understand': '私は送金手続きを自分の取引銀行から開始する必要があることを理解しています。<br />こちらをクリックして閉じる。',
  'instructions.offline.download.button': '銀行送金の手順をダウンロード',
  'instructions.offline.howToBankTransfer': '銀行振込の方法',
  'instructions.offline.howToBankTransfer.modal.title': '銀行送金を完了する方法',
  'instructions.offline.howToBankTransfer.modal.intro': '下記のその他の方法でも、銀行送金ができます:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': 'オンラインバンキング / モバイルバンキング',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription': 'ご利用の銀行のオンラインバンキングまたはモバイルアプリをお持ちの場合は、口座へログインして簡単にご自身で送金することができます。',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': '銀行窓口でのお手続き',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription': 'ご利用の銀行窓口へ行ってお支払いをする場合は、支払手順書に記載されている口座情報の必須事項を銀行に提供してください。',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'テレフォンバンキング',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription': 'ご利用の銀行に電話をし、銀行がお客様に代わって送金を開始することを承認することもできます。',
  'instructions.offline.referenceWarning': '弊社がお客様のお支払いを特定できるようにするため、参照としてこの情報を含めてください',
  'instructions.offline.dueDateLabel': '送金期限：',
  'instructions.offline.processingTime': 'Flywireによる資金の受領：送金手続きを開始してから<strong>2～3営業日後</strong>',
  'elementsInstructions.qr.description': 'QRコードをスキャンしてお支払いを完了してください',
  'elementsInstructions.qr.payid.description': 'Open your banking app and send to the PayID below. This address is assigned exclusively to your account — payments are matched automatically.',
  'elementsInstructions.qr.scan': 'またはスマートフォンのカメラでスキャンしてください',
  'elementsInstructions.qr.waitingForPayment': 'Awaiting payment completion',
  'elementsInstructions.externalAction.generic': '続行するには、お支払いを完了してください。',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone': '携帯電話にM-Pesaの支払いリクエストが送信されました。\n続行するには、お支払いを完了してください。',
  'elementsInstructions.redirect.title': 'Complete your payment',
  'elementsInstructions.redirect.description': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again.',
  'elementsInstructions.redirect.button': 'Make your payment',
  'documentCollector.collapsibleTitle': '書類をアップロード',
  'documentCollector.uploadingDocument': '取引の正当性を証明する資料のアップロード',
  'documentCollector.deleteFile': '{{fileName}}を削除',
  'documentCollector.deletingFile': '{{fileName}}を削除中',
  'documentCollector.moreInfoModal': '詳細',
  'documentCollector.errorsModal': 'Document warnings',
  'documentCollector.documentList': '取引の正当性を証明する資料一覧',
  'documentCollector.upload': 'アップロード',
  'documentCollector.errorBlockLabel': 'Document warnings',
  'documentCollector.reUpload': '再アップロード',
  'documentCollector.errorsFoundOne': '{{count}} Warning Found',
  'documentCollector.errorsFoundOther': '{{count}} Warnings Found',
  'documentCollector.validationNote': '<b>ファイルのアップロードが完了しました</b>自動スキャンにより、問題がある可能性が検出されました。書類に必要な情報がすべて含まれている場合は、この警告を無視してください。',
  'documentCollector.antivirus': 'ウイルス対策ファイルスキャン',
  'documentCollector.antivirusStep': 'アンチウイルスファイルスキャン1/2',
  'documentCollector.verifyingStep': '書類を確認中 2件/2件中',
  'documentCollector.invalidFile': '無効なファイルが検出されました。ファイルはパスワード保護または暗号化されている場合があります。確認して、もう一度試してください。',
  'documentCollector.moreInfo': '詳細',
  'documentCollector.required': '必須',
  'documentCollector.review': 'レビュー',
  'documentCollector.acceptedFileTypes': '受理可能なファイルの種類：<b>PDF</b>、<b>PNG</b>、<b>JPG</b>',
  'documentCollector.maxFileSize': '最大ファイルサイズ：<b>{{maxFileSize}}MB</b>',
  'documentCollector.acceptedFileAndFileSize': '受理可能なファイル形式：<b>PDF</b>、<b>PNG</b>、<b>JPG</b>。ファイルサイズの上限：<b>{{maxFileSize}}MB。</b>',
  'documentCollector.docVerifyError.missingInfo': '資料に必要とされるすべての情報が含まれているかを確認してください。',
  'documentCollector.docVerifyError.documentTypeError': '{{documentType}}はない可能性があります。要件を確認し、必要に応じて新しい書類をアップロードしてください。',
  'documentCollector.docVerifyError.documentIdentificationTypeError': 'アップロードされた取引の正当性を証明する資料は、このお支払いに選択された身元証明書類である「{{documentType}}」のように見受けられません。確認して、必要に応じて再アップロードしてください。',
  'documentCollector.docVerifyError.documentType.errorNote': '<b>注意</b>: 誤った書類を提出すると、支払い処理が遅れる可能性があります。書類が有効であれば、この警告は無視してください。',
  'documentCollector.duplicateFile': '取引の正当性を証明する資料の重複が検出されました。それぞれ異なるファイルをアップロードしてください。',
  'oneOff.savePaymentMethod.label': '今後のお支払いのため、この支払方法を保存してください',
  'lrs.transaction.title': '取引',
  'lrs.transaction.date': '日付',
  'lrs.transaction.amount': '金額',
  'lrs.transaction.amountHint': '外国通貨での金額',
  'lrs.transaction.adBranch': '外国通貨での取引を行なった支店名と住所',
  'lrs.transaction.add': '取引をさらに追加する',
  'lrs.signatureModal.title': 'ドキュメントに署名する',
  'lrs.signatureModal.tab.draw': '署名を手書き',
  'lrs.signatureModal.tab.upload': '署名をアップロード',
  'lrs.signatureModal.draw.text': '書類を受理するには、以下の所定欄にマウスか指で署名してください。',
  'lrs.signatureModal.legalAlert': '署名が無効な場合、LRSプロセスはすべて無効になります。署名には<b>PAN保有者の署名</b>を必ず使用してください。将来必要になる場合に備えて、提供された支払者のEメールに書類のコピーが送信されます。 受理可能なファイル形式：<b>PNG</b>、<b>JPG</b>。',
  'lrs.signatureModal.draw.clear': '消去',
  'lrs.signatureModal.upload.label': '署名の画像バージョンをアップロードしてください',
  'lrs.signatureModal.upload.input': '署名をアップロード',
  'lrs.signatureModal.upload.remove': '削除',
  'lrs.signatureModal.upload.hint': '受理可能なファイル形式：<b>PNG</b>、<b>JPG</b>。最大ファイルサイズ：<b>8MB</b>',
  'lrs.signatureModal.upload.typeError': 'このファイルの種類はサポートされていません。PNGまたはJPGをアップロードしてください。',
  'lrs.signatureModal.upload.sizeError': 'ファイルサイズは8MB未満',
  'lrs.signatureModal.upload.readError': 'ファイルを読み込めませんでした。もう一度お試しください。',
  'lrs.signatureModal.confirm': '同意して送信する',
  'lrs.signatureModal.previewError': 'プレビューの生成中に問題が発生しました。もう一度お試しください。',
  'lrs.signatureModal.uploadError': '送信中に問題が発生しました。もう一度お試しください。',
  'lrs.previewLink.label': 'ドキュメントのプレビュー',
  'lrs.documents.continueButton': 'LRS（送金自由化スキーム）書面の提出に進んでください',
  'lrs.form.declaration': '送金自由化スキーム (LRS) により、インド政府およびインド中央銀行 (RBI) は海外への送金に LRS 宣言書フォーム (正式名称は「A2 cum LRS Declaration」) が義務付けられました。銀行送金を始める前に、 LRS 宣言書提出が必須となります。フォームが提出されない場合、お支払い手続きが遅れる場合があります。この手順完了についての詳細は、<a href=\'https://help.flywire.com/hc/ja/articles/360012963774\' target=\'_blank\'>こちら</a>をクリックしてください。',
  'lrs.form.bankAccountAndStudentInfo.title': '銀行口座と学生情報',
  'lrs.form.bankAccountAndStudentInfo.text': '資金を振り込む銀行口座を指定してください。学生ローンを借りており、資金がローンの口座から支払われる場合は、口座番号をご提供ください。NRO/NREアカウントからの送金は受付けできません。学生番号欄には、学生番号、出願 ID、または参照番号を使用できます。',
  'lrs.form.details.title': '現在の会計年度中に行った海外取引の詳細',
  'lrs.form.details.text': '現在の会計年度（<b>{{startYear}}年4月～{{endYear}}年3月</b>）内に行った外貨取引についての詳細を入力してください。取引がない場合は空白のままにしてください。',
  'lrs.form.bankAccountNumber': '銀行口座番号',
  'lrs.form.studentFullName': '生徒の氏名',
  'lrs.form.studentId': '学生 ID',
  'lrs.form.required': '必須',
  'lrs.form.signAndSubmit': 'LRS（送金自由化スキーム）書面に署名・提出',
  'lrs.title': '書類をアップロードしてLRSフォームを提出',
  'lrs.description': 'この手順が完了すると、銀行送金の支払手順が表示されます。',
  'lrs.tabs.documents': '1. 書類をアップロード',
  'lrs.tabs.form': '2. LRS（送金自由化スキーム）書面を提出',
  'recipientFields.requiredField': '(*) は必須入力欄',
  'paymentMethodSelector.loading': '支払方法を読み込んでいます...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'デビットカードとクレジットカードが利用可能です',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'デビットカードが利用可能です',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'クレジットカードが利用可能です',
  'paymentMethodSelector.cards.surchargeWarning': 'カードの種類や発行国によっては、追加料金が発生する場合があります。',
  'paymentMethodSelector.subtitle.default': '{{methodName}}で支払い',
  'paymentMethodSelector.subtitle.google_pay': '保存したGoogle Payウォレットで支払う',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch IDまたはFace ID — Safariのみ',
  'paymentMethodSelector.subtitle.paypal': 'PayPalアカウントで支払う',
  'paymentMethodSelector.subtitle.wechat': 'WeChatで支払う — 中国本土で利用可能',
  'paymentMethodSelector.subtitle.alipay': 'Alipayで支払う',
  'paymentMethodSelector.subtitle.trustly': 'オープンバンキングによるお支払い'
} as const;
export { jaJP };
